module.exports = __webpack_public_path__ + "static/media/LH_Bay_only.ecd5d2d8.jpg";